/**
 * Canonical country identity.
 *
 * Restored 2026-09-17 from production OTA 2026-08-21 (module 1415); the file was
 * lost in the 2026-08-30 incident. functions/common/countryNormalize.js is the
 * server-side CommonJS mirror - if you change the canonical list or the alias
 * table here, change it there too.
 */

export const CANONICAL_COUNTRIES = [
  "benin",
  "burkina faso",
  "burundi",
  "cameroon",
  "canada",
  "democratic republic of the congo",
  "gabon",
  "ghana",
  "kenya",
  "lesotho",
  "malawi",
  "mozambique",
  "nigeria",
  "rwanda",
  "senegal",
  "sierra leone",
  "south africa",
  "tanzania",
  "uganda",
  "zambia",
];

export const COUNTRY_ALIASES = {
  // Tanzania
  "united republic of tanzania": "tanzania",
  "tanzania, united republic of": "tanzania",
  "the united republic of tanzania": "tanzania",

  // DR Congo
  "congo, democratic republic of the": "democratic republic of the congo",
  "democratic republic of congo": "democratic republic of the congo",
  "congo - kinshasa": "democratic republic of the congo",
  "congo-kinshasa": "democratic republic of the congo",
  "dr congo": "democratic republic of the congo",
  "drc": "democratic republic of the congo",

  // South Africa
  "republic of south africa": "south africa",
  "rsa": "south africa",

  // Underscored forms written by the admin panel's country pickers
  "burkina_faso": "burkina faso",
  "sierra_leone": "sierra leone",
  "south_africa": "south africa",
};

/**
 * Reduce any country spelling to its canonical key.
 * Unrecognised countries fall through lowercased/trimmed rather than dropped.
 */
export const normalizeCountry = (country) => {
  if (!country || typeof country !== "string") return "";
  const key = country.toLowerCase().trim().replace(/\s+/g, " ");
  if (!key) return "";
  if (CANONICAL_COUNTRIES.includes(key)) return key;
  return COUNTRY_ALIASES[key] || key;
};

export const isTanzaniaCountry = (country) => normalizeCountry(country) === "tanzania";

export const isSupportedCountry = (country) =>
  CANONICAL_COUNTRIES.includes(normalizeCountry(country));
